import { render, staticRenderFns } from "./producto_edicionstockmasivahistorico.vue?vue&type=template&id=404f8f4d"
import script from "./producto_edicionstockmasivahistorico.vue?vue&type=script&lang=js"
export * from "./producto_edicionstockmasivahistorico.vue?vue&type=script&lang=js"
import style0 from "./producto_edicionstockmasivahistorico.vue?vue&type=style&index=0&id=404f8f4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports